import * as React from 'react'
import H from 'history'
import { Widget, mk_widget } from 'widgets-for-react'
import { withRouter, RouteComponentProps } from 'react-router-dom'

export interface HistoryEvent { 
  location: H.Location<any>, 
  action: H.Action
}

export interface HistoryProps {
  on_done: (_:HistoryEvent) => void
}

export class HistoryComponent extends React.Component<RouteComponentProps & HistoryProps, {}> {
  
  private listener: H.UnregisterCallback
  
  constructor(props: RouteComponentProps & HistoryProps, context: any) {
    super(props, context)
    this.state = {}
  }

  componentDidMount() {
    this.listener = this.props.history.listen((location: H.Location<any>, action: H.Action) => {
      this.props.on_done({ location, action })
    })
  }

  componentWillUnmount() {
    this.listener()
  }

  render() {
    return null
  }
}

const HistoryComponentWithRouter = withRouter(HistoryComponent)

export let history = () : Widget<HistoryEvent> => {
  return mk_widget({
    run: (on_done: (output: HistoryEvent) => void) =>
      React.createElement<HistoryProps>(HistoryComponentWithRouter, {
        on_done
      })
  })
}